import { initialiseFilterKeyword } from './Filters/Keyword';
import { initialiseFilterAdvancedLocation } from './Filters/AdvancedLocation';
import { initialiseFilterSalarySlider } from './Filters/SalarySlider';

export const initialise = () => {
    const page = document.querySelector<HTMLBodyElement>('.job-results')
    const widget = document.querySelector<HTMLElement>('.search-filters-widget')
    if (!page || !widget) return

    initialiseFilterKeyword(widget)
    initialiseFilterAdvancedLocation(widget)
    initialiseFilterSalarySlider(widget)
    filterMenuGroupButtons(widget)
    filterOptionsDisplayList(widget)
    filterMenuChildren(widget)
}

const filterMenuGroupButtons = (widget: HTMLElement) => {
    const filters = widget.querySelectorAll<HTMLElement>('.optionfiltergroup')

    filters.forEach((filter: HTMLElement) => {
        const applyButtonContainer = filter.querySelector('.apply-filters-btn-container')
        const applyButton = filter.querySelector('.apply-filters-btn')
        const buttonContainer = filter.querySelector('.job-filter-buttons-container')
        const optionDisplayList = filter.querySelector('.option-display-list')

        if (!buttonContainer || !applyButton || !applyButtonContainer || !optionDisplayList) return
        buttonContainer.prepend(applyButton)
        applyButtonContainer.remove()
        optionDisplayList.appendChild(buttonContainer)
    })
}

const filterMenuClose = (filter: HTMLDivElement, button: HTMLButtonElement, list: HTMLUListElement) => {
    filter.classList.remove('category-opened')
    button.setAttribute('aria-expanded', 'false')
    list.setAttribute('aria-hidden', 'true')
    list.toggleAttribute('inert', true)
}

const filterOptionsDisplayList = (widget: HTMLElement) => {
    const filters: NodeListOf<HTMLDivElement> = widget.querySelectorAll('.optionfiltergroup, .location-filter, .salary-slider')

    filters.forEach((filter: HTMLDivElement) => {
        const button = filter.querySelector<HTMLButtonElement>('.option-type-header-text, .header')
        const list = filter.querySelector<HTMLUListElement>('.option-display-list, .location-slider-wrapper, .salary-slider__container')
        if (!button || !list) return

        button.setAttribute('aria-expanded', 'false')
        list.setAttribute('aria-hidden', 'true')
        list.toggleAttribute('inert', true)

        let outsideClickHandler: ((event: MouseEvent) => void) | null = null

        const closeFilter = () => {
            filterMenuClose(filter, button, list)
            if (outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        }

        const toggleFilter = () => {
            const isExpanded: boolean = filter.classList.toggle('category-opened')
            button.setAttribute('aria-expanded', isExpanded.toString())
            list.setAttribute('aria-hidden', (!isExpanded).toString())
            list.toggleAttribute('inert', !isExpanded)
            
            if (isExpanded) {
                outsideClickHandler = (event: MouseEvent) => {
                    if (!filter.contains(event.target as Node)) {
                        closeFilter()
                    }
                }
                document.addEventListener('click', outsideClickHandler)
            } else if (outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        }

        const observer = new MutationObserver(() => {
            if (!filter.classList.contains('category-opened') && outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        })
        observer.observe(filter, { attributes: true, attributeFilter: ['class'] })

        button.addEventListener('click', () => {
            toggleFilter()
        })
        
        button.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                toggleFilter()
            }
        })
        
        filter.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                button.focus()
                closeFilter()
            }
        })
        
        filter.addEventListener('focusout', (event: FocusEvent) => {
            if (event.relatedTarget && !filter.contains(event.relatedTarget as Node)) {
                closeFilter()
            }
        })
    })
}

const filterMenuChildrenToggle = (option: HTMLButtonElement, childList: HTMLUListElement) => {
    const isExpanded: boolean = option.classList.toggle('filter-opened')
    option.setAttribute('aria-expanded', isExpanded.toString())
    childList.setAttribute('aria-hidden', (!isExpanded).toString())
    childList.toggleAttribute('inert', !isExpanded)
}

const filterMenuChildren = (widget: HTMLElement) => {
    const options = widget.querySelectorAll<HTMLButtonElement>('.filter-option.has-child-elements')

    options.forEach((option: HTMLButtonElement) => {
        const button = option.querySelector<HTMLButtonElement>('.filter-expand-hide')
        const childList = option.querySelector<HTMLUListElement>('.child-list')
        if (!button || !childList) return

        button.setAttribute('aria-expanded', 'false')
        childList.setAttribute('aria-hidden', 'true')
        childList.toggleAttribute('inert', true)

        button.addEventListener('click', () => {
            filterMenuChildrenToggle(option, childList)
        })
    })
}
